module.exports = __webpack_public_path__ + "static/visitors.0a5a7ab2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/visitors.svg
// module id = 1003
// module chunks = 101932004231744